import type { Post } from "@/types/content";
import { posts as postsMock } from "@/mocks/cmsData";
import { getSanityClient, isSanityPostsEnabled } from "@/lib/sanity.client";
import { postsListQuery } from "@/lib/sanity.queries";
import { sanityDocToPost } from "@/lib/sanity.normalize";

let cache: Post[] | null = null;

/** 供開發或切換資料源時清空快取 */
export function clearPostsCache(): void {
  cache = null;
}

/**
 * 文章列表：設了 VITE_SANITY_PROJECT_ID 且非 `VITE_CONTENT_POSTS_SOURCE=mock` 時，
 * 向 Sanity 拉取 **已發布** 文件；失敗或無資料則回退 mock。
 */
export async function getPostsForContent(): Promise<Post[]> {
  if (cache) return cache;

  if (isSanityPostsEnabled()) {
    const client = getSanityClient();
    if (client) {
      try {
        const raw = await client.fetch<unknown[]>(
          postsListQuery,
          {},
          { perspective: "published" },
        );
        const list = Array.isArray(raw) ? raw : [];
        const mapped = list
          .map((row) => sanityDocToPost(row))
          .filter((p): p is Post => p !== null);
        if (mapped.length > 0) {
          cache = mapped;
          return cache;
        }
        console.warn("[sanity] 0 posts returned, using mock");
      } catch (e) {
        console.warn("[sanity] fetch failed, using mock", e);
      }
    }
  }

  cache = postsMock;
  return cache;
}
